<template>
  <div>
    <h2>{{ title }}</h2>
    <ul class="menu stays">
      <li class="l1" v-for="item in eachplan" :key="item.image">
        <span class="pic"
          ><img :src="require(`@/assets/img/${item.image}`)"
        /></span>
        <span class="name">{{ item.name }}</span>
        <span class="info" v-if="title === 'Stays'">
          <span class="sub">{{ item.sub }}</span>
          <span class="course"
            >{{ item.plan }} &yen;<b>{{ item.price }}</b></span
          >
          <span class="upgrade">{{ item.upgrade }}</span>
        </span>
        <span class="info" v-if="title === 'Gourmet'">
          <span class="course">{{ item.plan }} </span>
          <span class="upgrade">{{ item.upgrade }}</span>
        </span>
        <span class="info" v-if="title === 'Life'">
          <span class="course newline">{{ item.plan }} </span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    eachplan: Array,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/molecules/about/eachPlan.scss";
</style>
